import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: '100vh',
                bgcolor: 'background.default',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                textAlign: 'center',
            }}
        >
            <Typography variant="h1" component="h1" sx={{ fontWeight: 'bold', mb: 2, color: 'black' }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ mb: 3, color: 'black' }}>
                Oops! Page Not Found
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, maxWidth: 400, color: 'black' }}>
                The page you are looking for does not exist or has been moved.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/')}>
                Go to Home
            </Button>
        </Box>
    );
};

export default NotFoundPage;